import { onMounted, ref } from 'vue';
import { createUUID } from '@/util/uuid';
import type { AdobeDataComponent } from '@/directives/AdobeDataLayer';

export const useAdobeDataLayer = (input: {
	name: string;
	link?: string;
	title: string;
	type: string;
}) => {
	const componentId = ref(`${input.name}-${createUUID()}`);

	onMounted(() => {
		const componentData: AdobeDataComponent = {
			'@type': `ltnext/components/3rdparty/${input.name}/${input.type}`,
			'dc:title': input.title
		};
		if (input.link) {
			componentData['xdm:linkURL'] = input.link;
		}

		if (!window.adobeDataLayer) {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			window.adobeDataLayer = [] as any;
		}

		window.adobeDataLayer.push({
			component: {
				[componentId.value]: componentData
			}
		});
	});

	const trackLink = (href: string, interaction: Record<string, unknown>) => {
		const eventInfo = {
			event: 'cmp:click',
			eventInfo: {
				path: `component.${componentId.value}`
			},
			interaction
		};
		window.adobeDataLayer.push(eventInfo);
		window.location.assign(href);
	};

	return {
		componentId,
		trackLink
	};
};
